import { dew as _ENTimeUnitWithinFormatParserDew } from "./parsers/ENTimeUnitWithinFormatParser";
import { dew as _ENMonthNameLittleEndianParserDew } from "./parsers/ENMonthNameLittleEndianParser";
import { dew as _ENMonthNameMiddleEndianParserDew } from "./parsers/ENMonthNameMiddleEndianParser";
import { dew as _ENMonthNameParserDew } from "./parsers/ENMonthNameParser";
import { dew as _ENCasualYearMonthDayParserDew } from "./parsers/ENCasualYearMonthDayParser";
import { dew as _ENSlashMonthFormatParserDew } from "./parsers/ENSlashMonthFormatParser";
import { dew as _ENTimeExpressionParserDew } from "./parsers/ENTimeExpressionParser";
import { dew as _ENTimeUnitAgoFormatParserDew } from "./parsers/ENTimeUnitAgoFormatParser";
import { dew as _ENTimeUnitLaterFormatParserDew } from "./parsers/ENTimeUnitLaterFormatParser";
import { dew as _ENMergeDateRangeRefinerDew } from "./refiners/ENMergeDateRangeRefiner";
import { dew as _ENMergeDateTimeRefinerDew } from "./refiners/ENMergeDateTimeRefiner";
import { dew as _configurationsDew } from "../../configurations";
import { dew as _ENCasualDateParserDew } from "./parsers/ENCasualDateParser";
import { dew as _ENCasualTimeParserDew } from "./parsers/ENCasualTimeParser";
import { dew as _ENWeekdayParserDew } from "./parsers/ENWeekdayParser";
import { dew as _ENRelativeDateFormatParserDew } from "./parsers/ENRelativeDateFormatParser";
import { dew as _chronoDew } from "../../chrono";
import { dew as _SlashDateFormatParserDew } from "../../common/parsers/SlashDateFormatParser";
import { dew as _ENTimeUnitCasualRelativeFormatParserDew } from "./parsers/ENTimeUnitCasualRelativeFormatParser";
import { dew as _ENMergeRelativeDateRefinerDew } from "./refiners/ENMergeRelativeDateRefiner";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.createConfiguration = exports.createCasualConfiguration = exports.parseDate = exports.parse = exports.GB = exports.strict = exports.casual = void 0;
  const ENTimeUnitWithinFormatParser_1 = __importDefault(_ENTimeUnitWithinFormatParserDew());
  const ENMonthNameLittleEndianParser_1 = __importDefault(_ENMonthNameLittleEndianParserDew());
  const ENMonthNameMiddleEndianParser_1 = __importDefault(_ENMonthNameMiddleEndianParserDew());
  const ENMonthNameParser_1 = __importDefault(_ENMonthNameParserDew());
  const ENCasualYearMonthDayParser_1 = __importDefault(_ENCasualYearMonthDayParserDew());
  const ENSlashMonthFormatParser_1 = __importDefault(_ENSlashMonthFormatParserDew());
  const ENTimeExpressionParser_1 = __importDefault(_ENTimeExpressionParserDew());
  const ENTimeUnitAgoFormatParser_1 = __importDefault(_ENTimeUnitAgoFormatParserDew());
  const ENTimeUnitLaterFormatParser_1 = __importDefault(_ENTimeUnitLaterFormatParserDew());
  const ENMergeDateRangeRefiner_1 = __importDefault(_ENMergeDateRangeRefinerDew());
  const ENMergeDateTimeRefiner_1 = __importDefault(_ENMergeDateTimeRefinerDew());
  const configurations_1 = _configurationsDew();
  const ENCasualDateParser_1 = __importDefault(_ENCasualDateParserDew());
  const ENCasualTimeParser_1 = __importDefault(_ENCasualTimeParserDew());
  const ENWeekdayParser_1 = __importDefault(_ENWeekdayParserDew());
  const ENRelativeDateFormatParser_1 = __importDefault(_ENRelativeDateFormatParserDew());
  const chrono_1 = _chronoDew();
  const SlashDateFormatParser_1 = __importDefault(_SlashDateFormatParserDew());
  const ENTimeUnitCasualRelativeFormatParser_1 = __importDefault(_ENTimeUnitCasualRelativeFormatParserDew());
  const ENMergeRelativeDateRefiner_1 = __importDefault(_ENMergeRelativeDateRefinerDew());
  exports.casual = new chrono_1.Chrono(createCasualConfiguration(false));
  exports.strict = new chrono_1.Chrono(createConfiguration(true, false));
  exports.GB = new chrono_1.Chrono(createConfiguration(false, true));
  function parse(text, ref, option) {
    return exports.casual.parse(text, ref, option);
  }
  exports.parse = parse;
  function parseDate(text, ref, option) {
    return exports.casual.parseDate(text, ref, option);
  }
  exports.parseDate = parseDate;
  function createCasualConfiguration(littleEndian = false) {
    const option = createConfiguration(false, littleEndian);
    option.parsers.unshift(new ENCasualDateParser_1.default());
    option.parsers.unshift(new ENCasualTimeParser_1.default());
    option.parsers.unshift(new ENMonthNameParser_1.default());
    option.parsers.unshift(new ENRelativeDateFormatParser_1.default());
    option.parsers.unshift(new ENTimeUnitCasualRelativeFormatParser_1.default());
    return option;
  }
  exports.createCasualConfiguration = createCasualConfiguration;
  function createConfiguration(strictMode = true, littleEndian = false) {
    return configurations_1.includeCommonConfiguration({
      parsers: [new SlashDateFormatParser_1.default(littleEndian), new ENTimeUnitWithinFormatParser_1.default(), new ENMonthNameLittleEndianParser_1.default(), new ENMonthNameMiddleEndianParser_1.default(), new ENWeekdayParser_1.default(), new ENCasualYearMonthDayParser_1.default(), new ENSlashMonthFormatParser_1.default(), new ENTimeExpressionParser_1.default(strictMode), new ENTimeUnitAgoFormatParser_1.default(strictMode), new ENTimeUnitLaterFormatParser_1.default(strictMode)],
      refiners: [new ENMergeRelativeDateRefiner_1.default(), new ENMergeDateTimeRefiner_1.default(), new ENMergeDateRangeRefiner_1.default()]
    }, strictMode);
  }
  exports.createConfiguration = createConfiguration;
  //# sourceMappingURL=index.js.map
  return exports;
}